/**
 * Fenn customization: when the shopper taps the sticky mobile bar's
 * "Adicionar ao carrinho" button before choosing a size on the page, this
 * opens a small bottom drawer with the product's real size options instead
 * of letting the add-to-cart action fail silently.
 *
 * It intentionally does not reimplement variant selection: it moves the
 * real on-page <variant-picker> element into the drawer while it's open
 * (and back when it closes), so every bit of the theme's own variant /
 * availability / cart logic keeps working unchanged.
 */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var drawer = document.getElementById('FennSizeDrawer');
    if (!drawer) return; // Not a product page with sticky add-to-cart enabled

    var content = drawer.querySelector('[data-fenn-size-drawer-content]');
    var placeholder = document.createComment('fenn-variant-picker-placeholder');
    var isOpen = false;
    var variantObserver = null;
    var lastFocused = null;

    function getMainVariantPicker() {
      return document.querySelector('variant-picker[data-template-product-match="true"]');
    }

    function hasUnselectedOption(picker) {
      var radios = picker.querySelectorAll('input[type="radio"]');
      if (!radios.length) return false;
      return !picker.querySelector('input[type="radio"]:checked');
    }

    function openDrawer(triggerButton) {
      var picker = getMainVariantPicker();
      if (!picker) return;

      if (!content.contains(picker)) {
        picker.before(placeholder);
        content.appendChild(picker);
      }

      lastFocused = triggerButton || document.activeElement;

      drawer.hidden = false;
      document.body.classList.add('fenn-size-drawer-open');
      // Force layout so the opacity/transform transition actually runs.
      // eslint-disable-next-line no-unused-expressions
      drawer.offsetHeight;
      drawer.setAttribute('data-open', 'true');
      isOpen = true;

      var closeButton = drawer.querySelector('.fenn-size-drawer__close');
      if (closeButton) closeButton.focus();

      watchStickyAvailability();
    }

    function closeDrawer() {
      if (!isOpen) return;
      isOpen = false;
      drawer.removeAttribute('data-open');
      document.body.classList.remove('fenn-size-drawer-open');

      if (variantObserver) {
        variantObserver.disconnect();
        variantObserver = null;
      }

      window.setTimeout(function () {
        if (isOpen) return; // Reopened before the close animation finished
        drawer.hidden = true;
        var picker = content.querySelector('variant-picker');
        if (picker && placeholder.parentNode) {
          placeholder.replaceWith(picker);
        }
      }, 320);

      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function watchStickyAvailability() {
      var stickyAddToCart = document.querySelector('sticky-add-to-cart');
      if (!stickyAddToCart) return;

      if (variantObserver) variantObserver.disconnect();
      variantObserver = new MutationObserver(function () {
        if (stickyAddToCart.dataset.variantAvailable === 'true') {
          var button = stickyAddToCart.querySelector('.sticky-add-to-cart__button');
          closeDrawer();
          if (button && !button.disabled) button.click();
        }
      });
      variantObserver.observe(stickyAddToCart, { attributes: true, attributeFilter: ['data-variant-available'] });
    }

    // Intercept sticky add-to-cart clicks in the capture phase, before the
    // component's own click handler runs, so a missing size selection can
    // be redirected to the drawer instead of failing.
    document.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest('.sticky-add-to-cart__button');
        if (!button) return;

        var picker = getMainVariantPicker();
        if (!picker || !hasUnselectedOption(picker)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        openDrawer(button);
      },
      true
    );

    drawer.addEventListener('click', function (event) {
      if (event.target.closest('[data-fenn-size-drawer-close]')) {
        closeDrawer();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen) closeDrawer();
    });
  });
})();
